import React, { useEffect, useState, useRef } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CircularProgress,
    Button,
    Typography,
    Box,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Grid,
    ThemeProvider,
    Snackbar,
    Alert,
    Card,
    CardHeader,
    CardContent,
    Breadcrumbs,
    Link,
    Autocomplete,
    TextField,
    IconButton

} from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import { createTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import EventIcon from "@mui/icons-material/Event";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Add as AddIcon } from "@mui/icons-material";

const theme = createTheme({
    palette: {
        primary: {
            main: "#1e5d45", // Custom primary color
        },
    },
});

const StyledHr = styled("hr")(({ theme }) => ({
    border: 0,
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: theme.spacing(4, 0),
    opacity: 0.8,
}));


function SendBillingReminder() {

    const emailBodyRef = useRef(null);
    const fileInputRef = useRef(null);

    const handleImageInsert = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                if (emailBodyRef.current) {
                    const img = document.createElement('img');
                    img.src = e.target.result;
                    img.style.maxWidth = '100%';
                    emailBodyRef.current.appendChild(img);
                }
            };
            reader.readAsDataURL(file);
        }
    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ padding: "40px 60px" }}>
                <Card
                    variant="outlined"
                    style={{
                        marginTop: "40px",
                        marginBottom: "40px",
                        borderRadius: 0,
                    }}
                >
                    <CardHeader
                        title={
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Box display="flex" alignItems="center">
                                    <EventIcon
                                        sx={{
                                            fontSize: "40px",
                                            marginRight: "8px",
                                        }}
                                    />
                                    <Typography variant="h6">Client Retention</Typography>
                                </Box>
                                <Breadcrumbs
                                    aria-label="breadcrumb"
                                    separator={<NavigateNextIcon fontSize="small" />}
                                    sx={{ color: "white" }}
                                >
                                    <Typography sx={{ color: "#ffffff99" }}>
                                        Client Retention
                                    </Typography>
                                    <Typography
                                        component={Link}
                                        to="/manage-technicians"
                                        sx={{ color: "#ffffff", textDecoration: "none" }}
                                    >
                                        Send Billing Reminder
                                    </Typography>
                                </Breadcrumbs>
                            </Box>
                        }
                        sx={{
                            backgroundColor: "#1e5d45",
                            color: "white",
                            padding: "16px",
                        }}
                    />
                    <CardContent sx={{ padding: '20px' }}>
                        <Card variant="outlined" sx={{ padding: '20px' }}>
                            <CardHeader
                                title={
                                    <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                                        Billing Reminder
                                    </Typography>
                                }
                                sx={{ marginBottom: 2 }}
                            />
                            <Typography variant="body2" sx={{ marginBottom: 3 }}>
                                Email reminders will be sent to the client everyday after the billing is past the due date.
                            </Typography>

                            <TextField
                                label="Email Schedule"
                                value="8:00 AM"
                                fullWidth
                                margin="dense"
                                disabled
                            />

                            <TextField
                                label="Email Subject"
                                placeholder="Enter email subject"
                                fullWidth
                                margin="dense"
                                value="Reminder: Payment Overdue for Job Order [Job Order ID]"
                                disabled
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />


                            <TextField
                                label="Email Body"
                                placeholder="Enter email body"
                                fullWidth
                                margin="dense"
                                multiline
                                rows={12}
                                value={`Hello [Client Name],

We wanted to remind you that the payment for your job order is overdue as of [due date].

Total Amount: [amount]

You can see the complete report using the following link:

If you have any questions, feel free to contact us.

Thank you,
Boaz Pest Management Corp - Billing Team`}
                                disabled
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />



                        </Card>
                    </CardContent>
                </Card>
            </Box>


        </ThemeProvider >

    );

}


export default SendBillingReminder;